import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutUs from './components/AboutUs';
import Services from './components/Services';
import CaseStudies from './components/CaseStudies';
import Advantages from './components/Advantages';
import MainCTA from './components/MainCTA';
import ContactUs from './components/ContactUs';
import Footer from './components/Footer';
import ChatWindow from './components/ChatWindow';
import PrivacyPolicy from './components/PrivacyPolicy';
import Terms from './components/Terms';
import NotFound from './components/NotFound';
import SchemaMarkup from './components/SchemaMarkup';
import SEO from './components/SEO';

// Компонент для управления SEO на разных страницах
const SEOManager = () => {
  const location = useLocation();

  const getPageSEO = () => {
    switch (location.pathname) {
      case '/':
        return {
          title: 'IT Joy - Ваш надежный IT-партнер с 2005 года',
          description: 'IT Joy – ваш надежный IT-партнер с 2005 года. Мы строим и обслуживаем IT-инфраструктуру, которая работает на ваш бизнес, обеспечивая стабильность, безопасность и экономию.',
          keywords: 'IT-инфраструктура, IT-поддержка, IT-аутсорсинг, видеонаблюдение, сетевая инфраструктура, IP-телефония, системы мониторинга'
        };
      case '/privacy-policy':
        return {
          title: 'Политика конфиденциальности - IT Joy',
          description: 'Политика конфиденциальности IT Joy. Узнайте, как мы защищаем ваши персональные данные и обеспечиваем безопасность информации.',
          keywords: 'политика конфиденциальности, защита данных, IT Joy'
        };
      case '/terms':
        return {
          title: 'Условия использования - IT Joy',
          description: 'Условия использования услуг IT Joy. Ознакомьтесь с правилами предоставления IT-услуг и условиями сотрудничества.',
          keywords: 'условия использования, IT-услуги, IT Joy'
        };
      default:
        return {
          title: 'IT Joy - Ваш надежный IT-партнер',
          description: 'IT Joy – ваш надежный IT-партнер с 2005 года. Профессиональные IT-услуги для бизнеса.',
          keywords: 'IT-услуги, IT-поддержка, IT-аутсорсинг'
        };
    }
  };

  const { title, description, keywords } = getPageSEO();
  return <SEO title={title} description={description} keywords={keywords} />;
};

function App() {
  return (
    <Router basename="/">
      <div className="flex min-h-screen flex-col bg-white text-gray-800">
        <SchemaMarkup />
        <SEOManager />
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={
              <>
                <HeroSection />
                <AboutUs />
                <Services />
                <CaseStudies />
                <Advantages />
                <MainCTA />
                <ContactUs />
              </>
            } />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <ChatWindow />
      </div>
    </Router>
  );
}

export default App;
